export var defaultNamespaceStoreOptions = {
    dehydrater: function (outlet) { return outlet; },
    selectError: function () { return undefined; },
    selectHasValue: function () { return true; },
    selectValue: function (state) { return state; },
};
//# sourceMappingURL=NamespaceStoreOptions.js.map